import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getGallerySetupMoodsApi } from "./gallerysetup.api";

const initialState = {
    isLoading: false,
    error: null,
    moods: [],
}

export const getGallerySetupMoods = createAsyncThunk(
    "gallerysetup/moods",
    async(_, {rejectWithValue}) => {
        try {
            return await getGallerySetupMoodsApi();
        } catch (error) {
            console.log(error);
            return rejectWithValue(error.response?.data || error.msg)
        }
    }
)

const soundsSlice = createSlice({
    name: "GallerySetupSounds",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getGallerySetupMoods.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getGallerySetupMoods.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.moods = action.payload.data.moods;
            })
            .addCase(getGallerySetupMoods.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            })
    }
})

export default soundsSlice.reducer;